import {
  EMERGENT,
  EARLY,
  DEVELOPING,
  CONSOLIDATING,
  EXTENDING,
  EXEMPLARS,
  PLANNING,
  PROFESSIONAL,
  ASSESSMENT,
  EXEMPLARS_NAV_LIST,
  PLANING_NAV_LIST,
  ASSESSMENT_NAV_LIST,
  PROFESSIONAL_NAV_LIST,
} from './index';
import {
  WORDS as WORDS_EXEMPLAR,
  SENTENCES as SENTENCES_EXEMPLAR,
  WORDS_AND_SENTENCES as WORDS_AND_SENTENCES_EXEMPLAR,
} from './exemplar';

export const TEXT_PRESENTATION = 'text-presentation';
export const TEXT_STRUCTURE = 'text-structure';
export const LANGUAGE_FEATURES = 'language-features';

export const WORDS = 'words';
export const SENTENCES = 'sentences';
export const WORDS_AND_SENTENCES = 'words-and-sentences';

export const WRITING_PROFORMA = 'interactive-writing-proforma';

export const FIRST_EXEMPLAR_ROUTE: { [others: string]: string } = {
  [EMERGENT]: WORDS,
  [EARLY]: TEXT_PRESENTATION,
  [DEVELOPING]: TEXT_PRESENTATION,
  [CONSOLIDATING]: TEXT_PRESENTATION,
  [EXTENDING]: TEXT_PRESENTATION,
};

export const LEFT_NAV_BUTTON = [LANGUAGE_FEATURES, WORDS_AND_SENTENCES];
export const RIGHT_NAV_BUTTON = [TEXT_PRESENTATION, WORDS];
export const BOTH_NAV_BUTTON = [TEXT_STRUCTURE, SENTENCES];

export const laterModes = [TEXT_PRESENTATION, TEXT_STRUCTURE, LANGUAGE_FEATURES];
export const emergentModes = [WORDS, SENTENCES, WORDS_AND_SENTENCES];

export interface IData {
  redirectPage: string;
  btnText: string;
}

export const LEFT_NAV_DATA: { [index: string]: IData } = {
  [LANGUAGE_FEATURES]: {
    redirectPage: 'text-structure',
    btnText: 'Text Structure',
  },
  [WORDS_AND_SENTENCES]: {
    redirectPage: 'sentences',
    btnText: 'Sentences',
  },
};

export const RIGHT_NAV_DATA: { [index: string]: IData } = {
  [TEXT_PRESENTATION]: {
    redirectPage: 'text-structure',
    btnText: 'Text Structure',
  },
  [WORDS]: {
    redirectPage: 'sentences',
    btnText: 'Sentences',
  },
};

export const BOTH_NAV_DATA: { [index: string]: { [index: string]: IData } } = {
  [TEXT_STRUCTURE]: {
    left: {
      redirectPage: 'text-presentation',
      btnText: 'Text Presentation',
    },
    right: {
      redirectPage: 'language-features',
      btnText: 'Language Features',
    },
  },
  [SENTENCES]: {
    left: {
      redirectPage: 'words',
      btnText: 'Words',
    },
    right: {
      redirectPage: 'words-and-sentences',
      btnText: 'Words and Sentences',
    },
  },
};

export const TEACHER_FOCUS: { [index: string]: string } = {
  [TEXT_STRUCTURE]: 'Text Structure',
  [TEXT_PRESENTATION]: 'Text Presentation',
  [LANGUAGE_FEATURES]: 'Language Features',
  [WORDS]: WORDS_EXEMPLAR,
  [SENTENCES]: SENTENCES_EXEMPLAR,
  [WORDS_AND_SENTENCES]: WORDS_AND_SENTENCES_EXEMPLAR,
};

/**
 * Route names
 */
export const EXEMPLAR = 'exemplar';
export const SAVED_EXEMPLAR = 'saved_exemplar';
export const SAVED_PROFORMA = 'saved_proforma';

export const NAV_LIST: { [index: string]: string[] } = {
  [EXEMPLARS]: EXEMPLARS_NAV_LIST,
  [PLANNING]: PLANING_NAV_LIST,
  [ASSESSMENT]: ASSESSMENT_NAV_LIST,
  [PROFESSIONAL]: PROFESSIONAL_NAV_LIST,
};
